import { Component, type ReactNode, type ErrorInfo } from 'react';
import { chatLogger } from '@/utils/chatLogger';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Ловит ошибки рендеринга дочерних компонентов и показывает fallback.
 * Предотвращает крэш всего виджета из-за сломанного Markdown/медиа.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    chatLogger.alwaysError('[Larte Chat] Render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div
          style={{
            padding: '8px 12px',
            color: 'var(--text-secondary, #888)',
            fontSize: 'var(--font-size-sm, 13px)',
          }}
        >
          Не удалось отобразить сообщение
        </div>
      );
    }
    return this.props.children;
  }
}
